export default "__VITE_ASSET__BVVlPM1k__"